import { render, staticRenderFns } from "./companyInfoCard.vue?vue&type=template&id=ef400116&scoped=true"
import script from "./companyInfoCard.vue?vue&type=script&lang=js"
export * from "./companyInfoCard.vue?vue&type=script&lang=js"
import style0 from "./companyInfoCard.vue?vue&type=style&index=0&id=ef400116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef400116",
  null
  
)

export default component.exports